








import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  name: 'AdaptiveListContainer',

  props: {
    num: { type: Number, default: 1 },
    isOrderList: { type: Boolean, default: false }, // 是否有序列表
    useNestedStyle: { type: Boolean, default: false }, // 是否应用嵌套样式
  },

  setup(props) {
    const ulClass = computed(() => {
      if (props.num <= 1) {
        return 'no-list';
      }

      if (props.isOrderList) {
        return 'order-list';
      }

      return 'no-order-list';
    });

    return {
      ulClass,
    };
  },
});
